import type { Dispatch, ReactElement, SetStateAction } from 'react';
import type { DeliveryAddressDirectoryEntry, RegionMasterDto, RequestFormData } from '../../domain/types';
import type { WellMaster } from '../../domain/wells';
import { ProcurementRequestEditor } from '../forms/ProcurementRequestEditor';

export interface NewRequestModalProps {
  open: boolean;
  onClose: () => void;
  formData: RequestFormData;
  setFormData: Dispatch<SetStateAction<RequestFormData>>;
  wells: WellMaster[];
  activeRegions: RegionMasterDto[];
  deliveryAddresses: DeliveryAddressDirectoryEntry[];
  submitFieldErrorKeys?: readonly string[];
  onSubmit: () => void | Promise<void>;
  onSaveDraft: () => void;
  authFetch: (url: string, init?: RequestInit) => Promise<Response>;
}

export function NewRequestModal({
  open,
  onClose,
  formData,
  setFormData,
  wells,
  activeRegions,
  deliveryAddresses,
  submitFieldErrorKeys,
  onSubmit,
  onSaveDraft,
  authFetch
}: NewRequestModalProps): ReactElement | null {
  if (!open) {
    return null;
  }

  return (
    <div className="modal-backdrop" role="presentation">
      <div
        className="modal-dialog modal-dialog-wide"
        role="dialog"
        aria-labelledby="new-request-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-dialog-header">
          <h2 id="new-request-modal-title">New procurement request</h2>
          <button type="button" className="secondary icon-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        {/*
          Avoid wrapping in <form>: modal actions use plain buttons; a form could capture Enter incorrectly.
        */}
        <div className="grid">
          <ProcurementRequestEditor
            formData={formData}
            setFormData={setFormData}
            wells={wells}
            activeRegions={activeRegions}
            deliveryAddresses={deliveryAddresses}
            submitFieldErrorKeys={submitFieldErrorKeys}
            authFetch={authFetch}
          />
          <div className="row full-width modal-actions">
            <button type="button" onClick={() => void onSubmit()}>
              Submit for approval
            </button>
            <button type="button" className="secondary" onClick={() => void onSaveDraft()}>
              Save as draft
            </button>
            <button type="button" className="secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
